// extracted by mini-css-extract-plugin
var _1 = "FileDirectoryBreadcrumb-moduleFileDirectoryBreadcrumb__Mn2Jd Breadcrumb-modulesmall__UEqmt Breadcrumb-moduleBreadcrumb__Zi1mt Breadcrumb-modulelarge__Jxsa7";
export { _1 as "FileDirectoryBreadcrumb" }
